import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { EMainRoutes, EYmPageScreen } from 'shared/typings';
import { sendYmEvent } from 'shared/utils/sendYmEvent';

const ymPageScreenMap: Partial<{ [key in EMainRoutes]: EYmPageScreen }> = {
	[EMainRoutes.DASHBOARD]: EYmPageScreen.MAIN_SCREEN,
	[EMainRoutes.CATALOG]: EYmPageScreen.CATALOG_SCREEN,
	[EMainRoutes.CHANNELS]: EYmPageScreen.YOUR_CHANNELS_SCREEN,
	[EMainRoutes.CHANNEL]: EYmPageScreen.CHANNEL_DETAIL_SCREEN,
	[EMainRoutes.BRAND]: EYmPageScreen.BRAND_SCREEN,
	[EMainRoutes.FINANCES]: EYmPageScreen.FINANCE_SCREEN,
	[EMainRoutes.MORE]: EYmPageScreen.MENU_TAB_MORE,
	[EMainRoutes.POST]: EYmPageScreen.CREATE_POST_SCREEN,
};

export const useSendPageViewEvent = () => {
	const location = useLocation();

	useEffect(() => {
		const pageScreen = location.pathname.split('/')[1]
			? ymPageScreenMap[location.pathname.split('/')[1] as EMainRoutes]
			: EYmPageScreen.MAIN_SCREEN;

		sendYmEvent('page_view_screen', { page_screen: pageScreen, event_type: 'page_view' });
	}, [location.pathname]);
};
